/**
 * Canonical identity-provider identifiers returned by tenant discovery.
 * Adding a provider: add a constant here, a registry entry, and an icon asset.
 * @readonly
 */
export const IDP_PROVIDER = Object.freeze({
  MICROSOFT_ENTRA: "microsoft_entra",
  GOOGLE: "google",
  OKTA: "okta",
  PING: "ping",
  KEYCLOAK: "keycloak",
  AUTH0: "auth0",
  ONELOGIN: "onelogin",
  JUMPCLOUD: "jumpcloud",
  FORGEROCK: "forgerock",
  IBM_VERIFY: "ibm_verify",
  ORACLE_IDCS: "oracle_idcs",
  SALESFORCE: "salesforce",
  AWS_COGNITO: "aws_cognito",
  DUO: "duo",
  SAP_IAS: "sap_ias",
  GENERIC_OIDC: "generic_oidc",
  GENERIC_SAML: "generic_saml",
  CUSTOM: "custom",
});

/** @typedef {typeof IDP_PROVIDER[keyof typeof IDP_PROVIDER]} IdpProviderId */

export const IDP_PROTOCOL = Object.freeze({
  OIDC: "oidc",
  SAML: "saml",
});
